/**
 * =====================================================================
 * BANNER DE CONSENTIMENTO DE COOKIES (LGPD — LEI Nº 13.709/2018)
 * =====================================================================
 * Exibe aviso de privacidade discreto e elegante caso o usuário ainda
 * não tenha registrado seu consentimento. Respeita temas claro e escuro.
 * =====================================================================
 */

const STORAGE_KEY = 'rr_cookie_consent';

export function initCookieBanner(): void {
  // Se o consentimento já foi registrado, não exibir o banner
  if (localStorage.getItem(STORAGE_KEY)) {
    return;
  }

  // Criar elemento do banner
  const banner = document.createElement('aside');
  banner.id = 'rrCookieBanner';
  banner.setAttribute('aria-label', 'Aviso de Privacidade e Cookies');
  banner.className =
    'fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-50 p-5 rounded-2xl glass-nav bg-white/95 dark:bg-brand-darkSurface/95 border border-brand-lightBorder dark:border-brand-darkBorder shadow-2xl transition-all duration-500 transform translate-y-6 opacity-0';

  banner.innerHTML = `
    <div class="flex items-start gap-3.5">
      <div class="flex-shrink-0 w-8 h-8 rounded-full bg-brand-royal/10 dark:bg-brand-cyan/10 flex items-center justify-center text-brand-royal dark:text-brand-cyan mt-0.5">
        <svg class="w-4 h-4 fill-current" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M10 2a8 8 0 100 16 8 8 0 000-16zM8 9a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1zm1 4a1 1 0 102 0v-1a1 1 0 10-2 0v1z" clip-rule="evenodd" />
        </svg>
      </div>
      <div class="flex-grow text-xs text-slate-600 dark:text-slate-300 leading-relaxed">
        <p class="font-bold text-slate-900 dark:text-white text-sm mb-1">
          Privacidade & Cookies (LGPD)
        </p>
        <p>
          Utilizamos cookies essenciais para manter suas preferências (como o tema escuro) e garantir a segurança da sua navegação, em conformidade com a Lei nº 13.709/2018.
        </p>
        <div class="mt-2">
          <a href="/cookies/" class="text-brand-royal dark:text-brand-cyan font-bold hover:underline">
            Conheça nossa Política de Cookies →
          </a>
        </div>
      </div>
    </div>
    <div class="flex items-center justify-end gap-2 mt-4 pt-3 border-t border-slate-200/80 dark:border-white/10">
      <button id="cookieEssentialBtn" type="button" class="px-3.5 py-2 rounded-xl text-xs font-semibold text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors cursor-pointer">
        Apenas Essenciais
      </button>
      <button id="cookieAcceptBtn" type="button" class="px-4 py-2 rounded-xl text-xs font-bold text-white bg-gradient-to-r from-brand-royal to-brand-royalLight hover:from-brand-royalDark hover:to-brand-royal shadow-sm transition-all cursor-pointer">
        Aceitar
      </button>
    </div>
  `;

  document.body.appendChild(banner);

  // Animar entrada suave
  requestAnimationFrame(() => {
    banner.classList.remove('translate-y-6', 'opacity-0');
  });

  const closeBanner = (consentType: 'accepted' | 'essential') => {
    try {
      localStorage.setItem(STORAGE_KEY, consentType);
    } catch {
      // Ignorar caso localStorage bloqueado
    }
    banner.classList.add('translate-y-6', 'opacity-0');
    setTimeout(() => {
      banner.remove();
    }, 500);
  };

  const acceptBtn = document.getElementById('cookieAcceptBtn');
  const essentialBtn = document.getElementById('cookieEssentialBtn');

  if (acceptBtn) {
    acceptBtn.addEventListener('click', () => closeBanner('accepted'));
  }
  if (essentialBtn) {
    essentialBtn.addEventListener('click', () => closeBanner('essential'));
  }
}
